import type {
	LWApiPublicBillingStripePaymentBeginPaymentParamsRaw,
	LWApiPublicBillingStripePaymentBeginPaymentResultRaw,
} from '@liquidweb-dev/club-sauce/public/billing/stripe/payment/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'modules/queries/api';
import { BILLING_PAYMENT_INSTRUMENT_LIST_QUERY_KEY } from 'modules/queries/billing/payment/instrument/useList';

const useBillingStripeBeginPayment = () => {
	const queryClient = useQueryClient();

	return useMutation<
		LWApiPublicBillingStripePaymentBeginPaymentResultRaw,
		ApiErrorI,
		LWApiPublicBillingStripePaymentBeginPaymentParamsRaw
	>({
		mutationFn: (params) =>
			api.billing.stripe.payment.apiRaw.beginPayment(params),

		onSuccess: () => {
			// possible to add an instrument with this method so invalidate list of instruments
			queryClient.invalidateQueries({
				queryKey: [BILLING_PAYMENT_INSTRUMENT_LIST_QUERY_KEY],
			});
		},
	});
};

export default useBillingStripeBeginPayment;
